import { ReactNode, useEffect, useState } from 'react';
import { donedealBreakpoints } from 'styled-system';

type ScreenSize = 'small' | 'medium' | 'large';

const MEDIUM_QUERY = `(min-width: ${donedealBreakpoints.SCREEN_MEDIUM}px)`;
const LARGE_QUERY = `(min-width: ${donedealBreakpoints.SCREEN_LARGE}px)`;

const ResponsiveDisplay = (props: {
  small: boolean;
  medium: boolean;
  large: boolean;
  children: ReactNode;
}) => {
  const { small, medium, large, children } = props;

  const screenSize = useScreenSize();

  if (screenSize === 'small' && small) {
    return <>{children}</>;
  }
  if (screenSize === 'medium' && medium) {
    return <>{children}</>;
  }
  if (screenSize === 'large' && large) {
    return <>{children}</>;
  }
  return null;
};

function useScreenSize(): ScreenSize {
  // Setting the initial size to a fixed value to avoid differences
  // between the server and the client (which would cause hydration errors).
  const [screenSize, setScreenSize] = useState<ScreenSize>('large');

  useEffect(() => {
    const mediumQuery = window.matchMedia(MEDIUM_QUERY);
    const largeQuery = window.matchMedia(LARGE_QUERY);

    const update = () => {
      if (largeQuery.matches) setScreenSize('large');
      else if (mediumQuery.matches) setScreenSize('medium');
      else setScreenSize('small');
    };

    update();
    mediumQuery.addEventListener('change', update);
    largeQuery.addEventListener('change', update);
    return () => {
      mediumQuery.removeEventListener('change', update);
      largeQuery.removeEventListener('change', update);
    };
  }, []);

  return screenSize;
}

export default ResponsiveDisplay;
